module.exports = __webpack_public_path__ + "assets/17d71fc1d34d26dc366411c4f6f4b91d.png";